import sw from '@uswitch/ev-utils/switch'
import Image from '../../elements/imgix-img'

import ProductTable from './elements'
import { ButtonLink } from '../../elements/button-link'
import { getValue } from './utils'

const formatter = sw({
  'data.Value': ({ cell, data }) => (
    <ProductTable.data.Value
      value={getValue(cell.value, data)}
      unit={getValue(cell.unit, data)}
      subscript={getValue(cell.subscript, data)}
    />
  ),

  'data.Auto': ({ cell, data, headerImage }) => (
    <ProductTable.data.Auto text={getValue(cell.text, data)} headerImage={headerImage} />
  ),

  default: ({ cell }) => <div>{JSON.stringify(cell)}</div>,
})

const Cell = sw({
  'cells.Split': ({ cell, data, key, headerImage }) => (
    <ProductTable.cells.Split key={key}>
      <For each='content' of={cell.contents} index='key'>
        {Cell(content.type, { cell: content, data, key, headerImage })}
      </For>
    </ProductTable.cells.Split>
  ),

  'cells.Image': ({ cell, data, key, headerImage }) => (
    <ProductTable.cells.Image key={key} headerImage={headerImage}>
      <Image src={getValue(cell.image, data)} alt={getValue(cell.alt, data)} width='223px' />
    </ProductTable.cells.Image>
  ),

  'cells.Cta': ({ cell, data, key, headerImage }) => {
    const secondaryText = getValue(cell.secondary.text, data)
    const secondaryImage = getValue(cell.secondary.image, data)

    return (
      <ProductTable.cells.Cta
        key={key}
        primary={
          <ButtonLink variant='primary' href={getValue(cell.primary.href, data)} target='_blank'>
            {getValue(cell.primary.text, data)}
          </ButtonLink>
        }
        secondary={
          <If condition={secondaryText || secondaryImage}>
            <div
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <If condition={secondaryText}>
                <ButtonLink
                  variant='link'
                  href={getValue(cell.secondary.href, data)}
                  target='_blank'
                >
                  {secondaryText}
                </ButtonLink>
              </If>
              <If condition={secondaryImage}>
                <Image
                  src={secondaryImage}
                  alt={getValue(cell.secondary.imageAlt, data)}
                  height={75}
                />
              </If>
            </div>
          </If>
        }
        headerImage={headerImage}
      />
    )
  },

  'cells.Content': ({ cell, data, key, headerImage }) => {
    const label = formatter(cell.label.type, { cell: cell.label, data })

    return (
      <ProductTable.cells.Content
        key={key}
        label={label}
        accent={getValue(cell.accent, data) || false}
        headerImage={headerImage}
      >
        {formatter(cell.content.type, { cell: cell.content, data, headerImage })}
      </ProductTable.cells.Content>
    )
  },

  default: ({ cell, key }) => <div key={key}>{JSON.stringify(cell)}</div>,
})

export default Cell
